<template>
  <div>
    <Observer
      :options="{ rootMargin: '0px 0px -200px 0px', threshold: 1 }"
      @intersect="itisvisible"
    />
    <div
      class="offer-listing-card"
      :class="welcomeOffers.length === 1 ? 'width90' : ''"
    >
      <div @click="triggerOfferDetailsModal()">
        <img
          :src="staticImgBaseUrl + '/images/global/percentStar.svg'"
          class="star16"
        />
      </div>
      <div :class="welcomeOffers.length === 1 ? 'offer-text-1' : 'offer-text'">
        <p class="offer-title" @click="triggerOfferDetailsModal()">
          {{ dataTitle }}
        </p>
        <!-- <div v-if="appliedOfferPromo == dataPromoCode" class="d-flex">
          <img
            :src="staticImgBaseUrl + '/images/global/greentick.svg'"
            class="pr5"
          />
          <span class="offer-description-green pr5">{{
            "₹" + dataDiscount
          }}</span>
          <span class="offer-description">coupon savings</span>
        </div> -->
        <div>
          <span class="offer-description">{{ dataDescription }}</span>
        </div>
        <!-- <p
          class="offer-details-cta dt-hand"
          @click="triggerOfferDetailsModal()"
        >
          Know More
        </p> -->
      </div>
      <div class="pl8">
        <button
          @click="triggerOfferAppliedModal($event)"
          class="bold"
          :class="
            appliedOfferPromo === dataPromoCode
              ? 'disabledRemove'
              : 'btn small enabledbuttonhomescreen'
          "
        >
          {{ appliedOfferPromo === dataPromoCode ? "Selected" : "Select" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  EVENT_IMPRESSION_OFFERS,
  EVENT_CLICK_VIEWMORE_OFFER_CARD,
  EVENT_CLICK_OFFER_SELECT,
} from "../helpers/analyticsEvents";
import Observer from "./Observer.vue";

export default {
  name: "OfferCard",
  props: [
    "dataTitle",
    "dataPromoCode",
    "dataIndex",
    "dataDescription",
    "dataDiscount",
    "dataItemTnc",
  ],
  components: {
    Observer,
  },
  data() {
    return {
      staticImgBaseUrl,
    };
  },
  mounted() {
    // EVENT_IMPRESSION_OFFERS({
    //   sectionName: this.dataTitle,
    //   sectionPosition: this.dataIndex + 1,
    //   positionWithinSection: "",
    // });
    // console.log('offer-card', this.dataIndex);
  },
  methods: {
    triggerOfferDetailsModal() {
      EVENT_CLICK_VIEWMORE_OFFER_CARD({
        couponCode: this.dataPromoCode,
        sectionPosition: 1,
        positionWithinSection: this.dataIndex + 1,
        sectionName: this.dataTitle,
      });
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
        this.dataIndex
      );

      this.dataPromoCode &&
        this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
          campaignId: this.dataItemTnc,
        });
    },
    triggerOfferAppliedModal(event) {
      event?.stopPropagation();
      if (this.$store.state.Offers.appliedOfferPromo != this.dataPromoCode) {
        this.$store.commit(
          keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
          this.dataPromoCode
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
          this.dataIndex
        );
        EVENT_CLICK_OFFER_SELECT({
          subCategory: "selected",
          sectionPosition: 1,
          positionWithinSection: this.dataIndex + 1,
          category: this.dataPromoCode,
        });
        this.closeOfferDetailsModal();
        LocalStorageFunc.updateCouponCode(this.dataPromoCode);
        this.$store.commit(keyMapsMutation.UPDATE_MANUAL_OFFER, "");
        document.body.classList.add("body-stop-scroll-mobile");
        this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, true);
        setTimeout(this.closeAppliedModal, 3000);

        if (this.offerFailedMsg) {
          this.showOfferNotApplied = true;
          setTimeout(() => {
            this.showOfferNotApplied = false;
          }, 4000);
        }
      }
    },
    closeOfferDetailsModal(source) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false
      );
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
    },
    itisvisible() {
      EVENT_IMPRESSION_OFFERS({
        sectionName: this.dataTitle,
        sectionPosition: this.dataIndex + 1,
        positionWithinSection: "",
      });
    },
  },
  computed: {
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    appliedOfferPromo() {
      return this.$store.state.Offers.appliedOfferPromo;
    },
  },
};
</script>
